<template>
  <div class="view-product-plans">
    <h5 class="text-semibold mb-5">Precificação e planos</h5>
    <action-dispatcher
      action="product/getProduct"
      :parameters="$route.params.id"
      @success="loaded"
    >
      <template v-if="product">
        <div class="row mb-7">
          <div class="col-lg-6 mb-lg-0 mb-4">
            <info-card
              prefix=""
              title="Planos cadastrados"
              icon="ph ph-file-text"
              :value="pagination.count || 0"
            />
          </div>
          <div class="col-lg-6">
            <info-card
              prefix=""
              title="Garantia do produto"
              icon="ph ph-shield-check"
              :value="
                `
                ${product.warranty} dia${product.warranty == 1 ? '' : 's'}
                `
              "
            />
          </div>
        </div>
        <!-- <div class="row my-6">
          <div class="col-12 col-md-4 mt-4 mt-md-0">
            <div class="info">
              <h3>Status de vendas</h3>
              <bp-switch
                v-model="isActive"
                @change="changeStatus"
                style="min-height: unset;"
                label="Ativas"
                :disabled="
                  ['in_review', 'reject', 'draft'].includes(product.status)
                "
              />
            </div>
          </div>
        </div> -->

        <snow-switch
          v-model="isActive"
          @input="changeStatus"
          label="Ativar vendas"
          class="mb-3"
        />

        <snow-data-table-header
          addText="Novo plano"
          @add="newPlan"
          @searching="search"
          :date-picker="false"
          :filters="false"
          class="mb-5"
        />

        <div v-if="loading" class="text-center">
          <b-spinner variant="primary" />
        </div>

        <snow-data-table v-else :columns="columns" :data="plans" />

        <div class="d-flex justify-content-end mt-5">
          <snow-paginator
            v-model="currentPage"
            v-show="!loading"
            :pagination="pagination"
            @change-page="onPaginationUpdate"
          />
        </div>
      </template>
    </action-dispatcher>
  </div>
</template>

<script>
import { PERIODICITY_NAME_MAP } from "@/constants/date.js";
import { clearObject, formatMoney } from "@/functions/helpers";
import ProductActionsMixin from "@/mixins/productActions.js";
import copy from "copy-text-to-clipboard";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  data() {
    return {
      currentPage: 1,
      searchInput: "",
      loading: false,
      isActive: false,
      params: {
        product_id: this.$route.params.id,
        search: "",
        offset: 0
      }
    };
  },
  computed: {
    columns() {
      return [
        { name: "Nome", field: "name", size: "1fr" },
        {
          name: "Periodicidade",
          field: "periodicity",
          size: "1fr",
          transform: v => PERIODICITY_NAME_MAP[v]
        },
        {
          name: "Descrição",
          field: "description",
          size: "1fr",
          limit: 28
        },
        {
          name: "Preço",
          field: "price",
          size: "1fr",
          transform: v => `R$ ${formatMoney(v)}`
        },
        {
          name: "Cobrança",
          field: "num_max_payments",
          size: "1fr",
          transform: (v, item) =>
            item.num_max_payments
              ? `${item.num_max_payments} recorrência${
                  item.num_max_payments == 1 ? "" : "s"
                }`
              : "Até o cliente cancelar"
        },
        {
          name: "Teste grátis",
          field: "test_days",
          size: "1fr",
          transform: v => `${v || 0} dia${v == 1 ? "" : "s"}`
        },
        {
          name: "SCK",
          field: "scr",
          size: "1fr"
        },
        {
          name: "Status",
          field: "status",
          transform: this.formatStatus,
          color: v =>
            ({
              draft: "alert",
              active: "green",
              inactive: "negative"
            }[v]),
          type: "tag"
        },
        {
          name: "",
          type: "menu",
          options: this.itemActions
        }
      ];
    },
    ...mapState("product", ["product"]),
    ...mapState("plan", ["plans", "pagination"])
  },
  methods: {
    formatStatus(val) {
      const options = {
        draft: "Pendente",
        active: "Ativa",
        inactive: "Inativa"
      };
      return options[val] || val;
    },
    changePlanStatus(item) {
      this.$store
        .dispatch("plan/put", {
          id: item.id,
          status: item.status === "active" ? "inactive" : "active"
        })
        .then(() => {
          this.$message.success("Status do plano alterado com sucesso.");
          this.dispatch();
        })
        .catch(() => {
          this.$message.error("Erro ao alterar status do plano.");
        });
    },
    newPlan() {
      this.$router.push({
        name: "product-plans-new",
        params: { id: this.$route.params.id }
      });
    },
    changeStatus() {
      this.$store
        .dispatch("product/put", {
          id: this.$route.params.id,
          status: this.isActive ? "active" : "inactive"
        })
        .then(() => {
          this.$message.success(
            `Produto ${this.isActive ? "ativado" : "desativado"} com sucesso!`
          );
        })
        .catch(() => {
          this.$message.error("Erro ao atualizar status de vendas.");
          this.isActive = !this.isActive;
        });
    },
    loaded() {
      this.isActive = this.product.status === "active";
    },
    itemActions(item) {
      const actions = [];

      actions.push({
        label: "Editar",
        icon: "fa-light fa-pen",
        click: this.edit
      });

      actions.push({
        label: "Copiar link do plano",
        icon: "fa-light fa-link",
        click: this.copy
      });

      actions.push({
        label: "Duplicar plano",
        click: this.duplicate
      });

      actions.push({
        label: `${item.status === "active" ? "Desativar" : "Ativar"} plano`,
        class: item.status === "active" ? "text-danger" : "",
        click: this.changePlanStatus
      });

      if (this.plans.length > 1) {
        actions.push({
          label: "Excluir plano",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text:
              "Tem certeza que deseja excluir este plano? Seus clientes não poderão mais encontrar e comprar este plano.",
            variant: "negative",
            icon: "ph ph-trash",
            action: i => this.deletePlan(i.id),
            secondaryButtonText: "Cancelar",
            buttonText: "Excluir plano"
          }
        });
      }
      return actions;
    },
    edit(item) {
      this.$router.push({
        name: "product-plans-edit",
        params: { id: this.$route.params.id, plan_id: item.id }
      });
    },
    copy(item) {
      copy(item.url);
      this.$message.success("Link copiado");
    },
    duplicate(item) {
      this.$store
        .dispatch("plan/duplicate", item)
        .then(() => {
          this.refresh();
          this.$message.success("Plano duplicado.");
        })
        .catch(() => this.$message.error("Erro ao duplicar plano."));
    },
    deletePlan(id) {
      this.$store
        .dispatch("plan/delete", id)
        .then(() => {
          this.$message.success("Plano deletado");
          this.refresh();
        })
        .catch(() => this.$message.error("Erro ao deletar plano"));
    },
    refresh() {
      this.currentPage = 1;
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("plan/get", clearObject(this.params))
        .catch(() => {
          this.$message.error("Não foi possível carregar os planos");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.dispatch();
    },
    search(search) {
      this.params.search = search;
      this.refresh();
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>

<style lang="scss" scoped>
.view-product-plans {
  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid $neutral-100;
    padding: 16px;
    gap: 12px;
    height: 100%;
  }
}
</style>
